import React, { useState, useEffect } from 'react';
import ProgrammeInfo from '../ProgrammeInfo/ProgrammeInfo';
import CohortsCard from './CohortsCard';
import * as queries from "../../../utils/prismicQueries";
import client from '../../../utils/prismicHelpers';
import './cohort.css'
import HorizontalNav from './HorizontalNav';
const Cohorts = () => {
    function rebuildFP() {
            window.fullpage_api.reBuild()
      
    }
  

    const [cohortDoc, setCohortDoc] = useState(null)
    useEffect(() => {
        client
            .query({
                query: queries.cohortsInfo,
            })
            .then((response) => {
                const cohort = response.data.allCohortss.edges[0].node;
                setCohortDoc(cohort);

            })
            .catch((error) => {
                console.error(error);
            });
    });


    return (
        <div className="cohort-container">
            <div className="row pt-5">
                <div className="col-md-5">

                    <h1 className="subtitle ">{cohortDoc?.title[0]?.text}</h1>
                    <p className='body-text text-start'>{cohortDoc?.description[0]?.text}</p>
                    <div className="nav nav-tabs d-flex flex-column  align-items-start" id="nav-tab" role="tablist">
                       
                             {cohortDoc?.vertical_nav?.map((info,index) =><HorizontalNav key={index +1} index={index+1} info={info}/> )}
                             
                      
                    </div>
                </div>
                <div className="col-md-7 maxhsx">
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active " id="nav-1" role="tabpanel" aria-labelledby="nav-1-tab">
                            <div className="row  g-2  " >
                                {cohortDoc?.turbo_info?.map((cohortsInfo, index) => <CohortsCard key={index + 1} Info={cohortsInfo} />)}
                            </div>

                        </div>

                        <div className="tab-pane fade show " id="nav-2" role="tabpanel" aria-labelledby="nav-2-tab">
                            <div className="row  g-2  " >
                                {cohortDoc?.boost_info?.map((cohortsInfo, index) => <CohortsCard key={index + 1} Info={cohortsInfo} />)}
                            </div>

                        </div>
                        <div className="tab-pane fade show " id="nav-3" role="tabpanel" aria-labelledby="nav-3-tab">
                            <div className="row  g-2  " >
                                {cohortDoc?.ignite_info?.map((cohortsInfo, index) => <CohortsCard key={index + 1} Info={cohortsInfo} />)}
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cohorts;